import { get } from 'lodash'
import { diffDays, addDays } from '../utils'
import fieldHelpers from '../../../../../../ui-formly/fieldHelpers/index'

function formly() {
  var fields = [
    {
      className: 'row',
      fieldGroup: [
        fieldHelpers.simpleBoolField({ key: 'Guarantee', label: 'Has Guarantee?', className: 'col-xs-3' })
      ]
    },
    {
      className: 'row',
      fieldGroup: [
        fieldHelpers.simpleDateField({ key: 'DateStart', label: 'Start', className: 'col-xs-3' }),
        {
          ...fieldHelpers.simpleNumberField({ key: 'PerformanceDays', label: 'Performance Days', className: 'col-xs-3' }),
          watcher: {
            expression: function (field, scope) {
              return get(scope, 'model.DateEnd')
            },
            listener: function (field, newValue, oldValue, scope) {
              const { DateStart, DateEnd } = scope.model
              const diffInDays = diffDays(DateStart, DateEnd)
              if (diffInDays !== undefined) {
                scope.model.PerformanceDays = diffInDays
              }
            }
          }
        },
        {
          ...fieldHelpers.simpleDateField({ key: 'DateEnd', label: 'End', className: 'col-xs-3' }),
          watcher: {
            expression: function (field, scope) {
              return get(scope, 'model.PerformanceDays')
            },
            listener: function (field, newValue, oldValue, scope) {
              const { DateStart, PerformanceDays } = scope.model

              const dateEnd = addDays(DateStart, PerformanceDays)
              if (dateEnd) {
                scope.model.DateEnd = dateEnd
              }
            }
          }
        }
      ],
      hideExpression
    },
    {
      className: 'row',
      fieldGroup: [
        {
          key: "Notes",
          name: "Notes",
          type: "textarea",
          templateOptions: {
            label: "Notes",
            required: true,
            rows: 5,
          },
          className: 'col-xs-12'
        }
      ],
      hideExpression
    }
  ]

  return fields
}

function hideExpression($viewValue, $modelValue, $scope, options) {
  const { model } = options
  return !model.Guarantee
}

export default formly